module.exports = fox._r("images/slides/urban/slide_1_1.jpg", __webpack_public_path__ + "images/slides/urban/slide_1_1.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_1_1.jpg
// module id = 48
// module chunks = 2